export default {
  action: 'change_tag',
  name: 'replaceInvalidTag',
  reducer: state => state ?? null,
  doReplaceInvalidTag: ({ payload, apiFetch }) => {
    const body = payload.map(([entity, newTag]) => ({ [entity.id]: newTag }))
    return apiFetch('/plantBatches/change_tag/', body, { method: 'PUT' })
  }
}
